// providing the standard colors used in tailwind
export enum ThemeColors {
    // two options. either define a component in the globals.css and assign it here:
    GreenFill = "green-fill",
    GrayFill = "gray-fill",
    BlueFill = "blue-fill",
    RedFill = "red-fill",
    // or use the predefined tailwindcss classes directly to define a set of classes:
    GrayText = "text-gray-200 dark:text-gray-500",
    GreenText = "text-green-200 dark:text-green-500",
}

export enum ThemeSizes {
    Small = 4,
    Medium = 5,
    Large = 10,
}
